import i18n from "i18n-js"

const currencies = {
  "en-US": "USD",
  fr: "EUR",
}

export const formatCurrency = (
  amount: number,
  minimumFractionDigits = 0,
  maximumFractionDigits = 2,
) => {
  const currency = currencies[i18n.locale] || "USD"

  const intlNumber = new Intl.NumberFormat(i18n.locale, {
    style: "currency",
    currency,
    minimumFractionDigits,
    maximumFractionDigits,
  })

  // always rounds up when there are no fraction digits
  return intlNumber.format(maximumFractionDigits > 0 ? amount : Math.ceil(amount))
}

export const formatNumber = (
  amount: number,
  minimumFractionDigits = 0,
  maximumFractionDigits = 2,
) => {
  return new Intl.NumberFormat(i18n.locale, {
    minimumFractionDigits,
    maximumFractionDigits,
  }).format(amount)
}

export const formatPrice = (amount: number) => {
  return amount.toFixed(2).replace(/\.?0+$/, "")
}
